/***
 *
 *   APP LAYOUT
 *   Main application layout containing the navigation
 *   and header (title, secondary nav and signed in user)
 *
 *   PROPS
 *   title: title of the view
 *
 **********/

import { Fragment, useContext } from 'react'
import { AuthContext, AppNav, Header, User } from 'components/lib'
import Style from './app.module.scss'

export function LandingPage(props) {
	// context & style
	const context = useContext(AuthContext)
	const user = JSON.parse(localStorage.getItem('user'))
	let routes =
		user?.permission == 'admin'
			? [
				// { label: 'Hypothesis', icon: 'activity', link: '/updatehypothesis' },
				// { label: 'Experiment', icon: 'user', link: '/experiment' },
				// { label: 'Insight', icon: 'help-circle', link: '/insight' },
				// { label: 'Products', icon: 'user', link: '/allprojects' },
				{ label: 'Home', icon: 'home', link: '/' },
				{ label: 'Dashboard', icon: 'activity', link: '/dashboard/null' },
				{ label: 'Derisky MBA', icon: 'activity', link: '/mba' },
				{ label: 'Blog', icon: 'activity', link: 'https://lab.derisky.ai/blog' },
				{ label: 'Derisky Lab', icon: 'activity', link: 'https://lab.derisky.ai/' },
				{ label: 'DEX Launch', icon: 'activity', link: 'https://lab.derisky.ai/dex' },
				{ label: 'Account', icon: 'user', link: '/account' },
				{ label: 'Help', icon: 'help-circle', link: '/help' },
				{ label: 'Sign Out', icon: 'log-out', action: context.signout }
			]
			: [
				// { label: 'Hypothesis', icon: 'activity', link: '/updatehypothesis' },
				// { label: 'Experiment', icon: 'user', link: '/experiment' },
				{ label: 'Blog', icon: 'activity', link: 'https://lab.derisky.ai/blog' },
				{ label: 'Derisky Lab', icon: 'activity', link: 'https://lab.derisky.ai/' },
				{ label: 'DEX Launch', icon: 'activity', link: 'https://lab.derisky.ai/dex' },
				// { label: 'Insight', icon: 'help-circle', link: '/insight' },
				// { label: 'Products', icon: 'user', link: '/allprojects' },
				{ label: 'Home', icon: 'home', link: '/' },
				{ label: 'Dashboard', icon: 'activity', link: '/dashboard/null' },
				{ label: 'Account', icon: 'user', link: '/account' },
				{ label: 'Help', icon: 'help-circle', link: '/help' },
				{ label: 'Sign Out', icon: 'log-out', action: context.signout }
			]
	return (
		<Fragment>
			{/* <AppNav items={routes} /> */}

			<main >

				{<props.children {...props.data} />}
			</main>
		</Fragment>
	)
}
